import { useMemo } from 'react';
import { Card, Table, TableBody } from '@mui/material';
import { PageContainer } from 'src/components/page-container';

import {
  TableHeadCustom as TableHead,
  TableNoData,
  TablePaginationCustom,
  getComparator,
  useTable,
  DataTableContainer,
} from 'src/components/table';
import { CustomBreadcrumbs } from 'src/components/custom-breadcrumbs/custom-breadcrumbs';

import { useGetAllTableTexts } from 'src/api/admin';

import { useLocales } from 'src/locales';
import { ITableTextItem } from 'src/types/table-text';
import TableTextTableRow from '../list/table-text-table-row';

export default function TableTextListView() {
  const { t } = useLocales('tableTextPage');
  const table = useTable();

  const { data: tableData = [] } = useGetAllTableTexts();

  const dataFiltered = useMemo(
    () =>
      [...tableData].sort(
        getComparator(table.order, table.orderBy) as unknown as (
          a: ITableTextItem,
          b: ITableTextItem,
        ) => number,
      ),
    [tableData, table.order, table.orderBy],
  );

  const TABLE_COLUMNS = useMemo(
    () => [
      { field: 'name', title: t('table_name') },
      { field: '', title: '' },
    ],
    [t],
  );

  return (
    <PageContainer variant="data">
      <CustomBreadcrumbs
        heading={t('table_text_title')}
        links={[{ name: t('admin') }, { name: t('table_text_title') }]}
        sx={{ mb: { xs: 3, md: 5 } }}
      />

      <Card>
        <DataTableContainer>
          <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 720 }}>
            <TableHead
              order={table.order}
              orderBy={table.orderBy}
              headLabel={TABLE_COLUMNS}
              onSort={table.onSort}
            />
            <TableBody>
              {dataFiltered.map((row) => (
                <TableTextTableRow key={row.key} row={row} />
              ))}
              <TableNoData notFound={dataFiltered.length === 0} />
            </TableBody>
          </Table>
        </DataTableContainer>

        <TablePaginationCustom
          count={tableData.length}
          page={table.page}
          rowsPerPage={table.rowsPerPage}
          onPageChange={table.onChangePage}
          onRowsPerPageChange={table.onChangeRowsPerPage}
          dense={table.dense}
          onChangeDense={table.onChangeDense}
        />
      </Card>
    </PageContainer>
  );
}
